module.exports = __webpack_public_path__ + "static/portfolio-mas-15-3cd6a2e80e46fb858e54ad2fb43c9caa.jpg";